import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=dbad3e0e&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=dbad3e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbad3e0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbad3e0e')) {
      api.createRecord('dbad3e0e', component.options)
    } else {
      api.reload('dbad3e0e', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=dbad3e0e&scoped=true&", function () {
      api.rerender('dbad3e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductCard.vue"
export default component.exports